// 任务
const OrderConfirm = () => import('@/views/task/orderConfirm/Index')
const OrderConfirmDeatil = () => import('@/views/task/orderConfirm/Detail')

const ReturnGroup = () => import('@/views/task/returnGroup/Index')
const ReturnGroupDeatil = () => import('@/views/task/returnGroup/Detail')

const CostChange = () => import('@/views/task/costChange/Index')
const CostChangeDetail = () => import('@/views/task/costChange/Detail')

const RequestFund = () => import('@/views/task/requestFund/Index')
const RequestFundDetail = () => import('@/views/task/requestFund/Detail')

const Follow = () => import('@/views/task/follow/Index')
const FollowAdd = () => import('@/views/task/follow/Add')
const FollowDetail = () => import('@/views/task/follow/Detail')

export default [
  {
    path: '/task/orderconfirm',
    component: OrderConfirm,
    meta: {
      title: '订单确认审核'
    },
  },
  {
    path: '/task/orderconfirm/detail',
    component: OrderConfirmDeatil,
    meta: {
      title: '订单确认审核'
    }
  },
  {
    path: '/task/returngroup',
    component: ReturnGroup,
    meta: {
      title: '退团审核'
    },
  },
  {
    path: '/task/returngroup/detail',
    component: ReturnGroupDeatil,
    meta: {
      title: '退团审核'
    }
  },
  {
    path: '/task/costchange',
    component: CostChange,
    meta: {
      title: '费用变更'
    }
  },
  {
    path: '/task/costchange/detail',
    component: CostChangeDetail,
    meta: {
      title: '费用变更审核'
    }
  },
  {
    path: '/task/requestfund',
    component: RequestFund,
    meta: {
      title: '请款单'
    }
  },
  {
    path: '/task/requestfund/detail',
    component: RequestFundDetail,
    meta: {
      title: '请款单审核'
    }
  },
  {
    path: '/task/follow',
    component: Follow,
    meta: {
      title: '跟进记录'
    }
  },
  {
    path: '/task/follow/add',
    component: FollowAdd,
    meta: {
      title: '添加跟进记录',
      ignoreBackTop: true
    }
  },
  {
    path: '/task/follow/detail',
    component: FollowDetail,
    meta: {
      title: '跟进记录'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/task.js